import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';

// Static, and before boot(): it has to read window.location while the link
// that brought the visitor here is still on it, which is only true until the
// Supabase client initialises. See lib/authlanding.ts.
import './lib/authlanding';

const root = createRoot(document.getElementById('root')!);

/**
 * App and client are imported lazily so a configuration failure lands here
 * rather than crashing the module graph before React exists. Without this a
 * deploy missing its build variables serves a blank white page.
 */
async function boot() {
  try {
    const { default: App } = await import('./App');
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>,
    );
  } catch (err) {
    root.render(
      <div className="boot-error">
        <h1>Nocturn is not configured</h1>
        <p className="muted">
          The site built without the settings it needs to reach the backend, so there is
          nothing to show. This is a deploy configuration problem, not something you did.
        </p>
        <pre>{err instanceof Error ? err.message : String(err)}</pre>
      </div>,
    );
  }
}

void boot();
